import React from "react";
import { Link } from 'react-router-dom'
import Header from "../../Components/Header";
import UniversalBanner from "../../Components/UniversalBanner";
import Footer from "../../Components/Footer";
import Newsletter from "../../Components/Newsletter";
import UserSideBar from "./Components/Sidebar";
import {
    UserImg,
} from "../../Constant/Index";
const InfoUser = () => {
    const UserData = [
        {
            FirstName: "Alaxender",
            LastName: "Alaxender Volk",
            Email: "AlaxenderVolk@Outlook.Com",
            Contact: "+(111) - 456 - 789",
            DOB: "12, June 2023"
        }
    ]
    return (
        <>
            <Header />
            <UniversalBanner heading="My Profile" />
            <section className="profile-main">
                <div className="container">
                    <div className="profile-start">
                        <div className="row">
                            <UserSideBar />
                            <div className="col-lg-9 col-md-8">
                                <div className="profile-box">
                                    <div className="top-heading d-flex gap-4 align-items-center pb-4">
                                        <h3 className="md-heading min-width-fit mb-0">User Info</h3>
                                        <hr className="w-100" />
                                    </div>
                                    <div className="userphoto-edit pb-3">
                                        <div className="photo">
                                            <figure>
                                                <img src={UserImg} alt="" className="img-here" />
                                            </figure>
                                            <div className="data">
                                                <span className="username">Photo</span>
                                                <span className="change-upload"><label htmlFor="" className="chang-img">Upload / Change Photo</label></span>
                                            </div>
                                        </div>
                                        <Link className="edit-profile text-decoration-underline line-height-2" to="/user/editprofile">
                                            <span className="svg-here">
                                                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M18.2467 5.55853L9.71264 14.0925C8.86282 14.9423 6.34015 15.336 5.77658 14.7724C5.21301 14.2088 5.59767 11.6862 6.4475 10.8364L14.9905 2.29339C15.2012 2.06354 15.4562 1.87878 15.7403 1.75023C16.0243 1.62168 16.3315 1.552 16.6433 1.54543C16.9549 1.53888 17.2648 1.59554 17.554 1.71202C17.8432 1.8285 18.1059 2.0024 18.326 2.22317C18.5462 2.44395 18.7194 2.70704 18.835 2.99657C18.9507 3.28611 19.0066 3.59607 18.9992 3.90778C18.9918 4.21948 18.9212 4.52649 18.7919 4.81019C18.6626 5.0939 18.4771 5.34848 18.2467 5.55853Z" stroke="#FFF8E9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M9.05098 3.41211H4.57821C3.62921 3.41211 2.71913 3.78909 2.04809 4.46014C1.37705 5.13119 1 6.04132 1 6.99032V15.9359C1 16.8849 1.37705 17.795 2.04809 18.466C2.71913 19.1371 3.62921 19.5141 4.57821 19.5141H14.4183C16.3953 19.5141 17.102 17.9039 17.102 15.9359V11.4631" stroke="#FFF8E9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            </span>
                                            Edit Profile
                                        </Link>
                                    </div>
                                    <hr />
                                    <div className="user-data">
                                        {
                                            UserData.map((mydata, index) => (
                                                <div className="row mt-4 mb-4 pb-3" key={index}>
                                                    <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                                                        <div className="single-data">
                                                            <span className="data-question">First Name*</span>
                                                            <span className="data-answer">{mydata.FirstName}</span>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                                                        <div className="single-data">
                                                            <span className="data-question">Last Name*</span>
                                                            <span className="data-answer">{mydata.LastName}</span>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                                                        <div className="single-data">
                                                            <span className="data-question">Email Address</span>
                                                            <span className="data-answer">{mydata.Email}</span>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                                                        <div className="single-data">
                                                            <span className="data-question">Contact Number*</span>
                                                            <span className="data-answer">{mydata.Contact}</span>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                                                        <div className="single-data">
                                                            <span className="data-question">Date Of Birth*</span>
                                                            <span className="data-answer">{mydata.DOB}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                    <hr />
                                    <div className="user-data">
                                        <div className="row">
                                            <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                                                <div className="single-data">
                                                    <span className="data-question">Password</span>
                                                    <span className="data-answer change-pass">*************** <Link className="change-pass" to="/user/updatepassword">Change Password</Link></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
            <Newsletter />
            <Footer />
        </>
    )
}
export default InfoUser;